/*
 * @Author: Dom
 * @Date: 2022-07-07 10:34:30
 * @LastEditTime: 2022-08-03 10:31:06
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\services\useraddress.ts
 */
import request from '@/utils/request'
import {UserAddressParamsType} from './data.d'

export async function getUserAddressList(params:UserAddressParamsType): Promise<any>{
    return request({
        url: '/seller/v1/userAddress/getUserAddressList',
        method: 'POST',
        data: params
    })
}

//获取站点信息
export async function getStationList(params:any): Promise<any>{
    return request({
        url: '/seller/v1/station/getList',
        method: 'POST',
        data: params
    })
}
